import {client} from './client'
import Sequence from '../models/sequence'

export default {
  index (query) {
    return client.get('/sequences', {
      params: query
    })
  },
  show (id) {
    return client.get('/sequences/' + id + '?include=reel,fund')
      .then((response) => {
        return new Sequence(false, response.data.data)
      })
  },
  prev (id) {
    return client.get('/sequences/' + id + '/prev?include=reel,fund')
  },
  next (id) {
    return client.get('/sequences/' + id + '/next?include=reel,fund')
  },
  store (data) {
    return client.post('/sequences', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/sequences/' + id, data.prepareForSend())
  },
  delete (id) {
    return client.delete('/sequences/' + id)
  },
  deleteImage (sequenceId, imageId) {
    return client.delete('/sequences/' + sequenceId + '/sequenceimage/' + imageId)
  }
}



// WEBPACK FOOTER //
// ./src/api/sequences.js